var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("app-detail-header", {
        attrs: {
          "show-toggle": true,
          "show-new": false,
          "show-print": false,
          "show-delete": true,
          "show-save": false,
        },
        on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
      }),
      _c("div", { staticClass: "columns is-gapless" }, [
        _c(
          "div",
          { staticClass: "column is-narrow" },
          [
            _vm.entity
              ? _c("emailsmslog-side-menu", { ref: "sideMenu" })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column" },
          [
            _vm.entity
              ? _c("router-view", {
                  key: _vm.$route.fullPath,
                  ref: "currentChild",
                  attrs: { "is-tiled": false, "route-name": _vm.$route.name },
                  on: {
                    entityDelete: function ($event) {
                      return _vm.onEntityDelete()
                    },
                  },
                  model: {
                    value: _vm.entity,
                    callback: function ($$v) {
                      _vm.entity = $$v
                    },
                    expression: "entity",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm.entity
        ? _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isConfirmModalActive,
                "ok-text": "Yes",
                "cancel-text": "No",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isConfirmModalActive = $event
                },
                ok: function ($event) {
                  return _vm.deleteEntity(true)
                },
                cancel: function ($event) {
                  return _vm.deleteEntity(false)
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Delete Email/SMS Log"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [_vm._v(" Email/SMS Log will be deleted. Continue? ")]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }